/**
 * @desc 根据ids查询查询buSub
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BuSbuResponseDtoRpc>>;
export function request(body: Array<number>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/buSub/getByIds`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
